import { DefaultService } from "@/api/SolarCloudApi";
import { QueryConfig } from "@/lib/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export default function getTrackerEventsQueryOptions() {
  return queryOptions({
    queryKey: ["trackerEvents"],
    queryFn: getTrackerEvents,
    staleTime: 30 * 1000,
    refetchInterval: 60 * 1000,
  });
}

async function getTrackerEvents() {
  const response = await DefaultService.trackerEventsGet();
  return response.collection;
}

type useTrackerEventsOptions = {
  queryConfig?: QueryConfig<typeof getTrackerEventsQueryOptions>;
};

export function useTrackerEvents({
  queryConfig,
}: useTrackerEventsOptions = {}) {
  return useQuery({
    ...getTrackerEventsQueryOptions(),
    ...queryConfig,
  });
}
